import React from 'react';
import './Home.css';

const HomePage = () => {
  return (
    
    <div className="home-page">
     {/* <h4 >HOME PAGE
     </h4> */}
    <h3>Welcome to the ERP PMPC Application!</h3>
    <h4>We're excited to have you on board. This platform is designed to streamline your work processes and enhance your productivity.</h4>
    </div>
  );
};

export default HomePage;
